module.exports = __webpack_public_path__ + "assets/icon-twitter.456030c8.svg";